export function UIRight({ world }) {
    return <div className="game-ui-right-root">
        
    </div>
}